import React, { useEffect, useState } from 'react';
import './../../Assets/CSS/Info.css'; 
import axios from 'axios';
import { BASE_URL, BASE_FILE_URL, BASE_PAYMENT_URL } from './../../Environment'; 
import { toast } from 'react-toastify';
import { FaCircleUser } from 'react-icons/fa6'; 
import { format } from 'date-fns';
  
function Info() { 
    const accessToken = localStorage.getItem('accessToken'); 
    const [details, setDetails] = useState([]); 
    useEffect(() => {
        axios.get(`${BASE_URL}/agent/details`, {
            headers: {  
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setDetails(res.data.data); 
        }).catch((res) => {
            if (res.response.status === 401) {
                ['loginAs', 'accessToken'].forEach(item => localStorage.removeItem(item)); 
                window.location.reload();  
            } else {
                toast.error(res.response.data.msg, { autoClose: 3000 }); 
            } 
        });  
    }, []); 
    const today = new Date();
    const expiryDate = new Date(details.expiration_date);  
    today.setHours(0, 0, 0, 0);  
    const isExpired = expiryDate < today; 
    const upgradeAccount = async () => {
        const id = details.id;  
        axios.post(`${BASE_URL}/agent/payment`, { id }, {
            headers: {       
                'Content-Type': 'application/json' 
            } 
        }).then((res) => {  
            if (res.data.encrypted_data && res.data.access_code) { 
                const form = document.createElement('form');
                form.method = 'post';
                form.action = BASE_PAYMENT_URL;  
                const encRequestInput = document.createElement('input');
                encRequestInput.type = 'hidden';
                encRequestInput.name = 'encRequest';
                encRequestInput.id = 'encRequest';
                encRequestInput.value = res.data.encrypted_data;
                form.appendChild(encRequestInput); 
                const accessCodeInput = document.createElement('input');
                accessCodeInput.type = 'hidden';
                accessCodeInput.name = 'access_code';
                accessCodeInput.id = 'access_code';
                accessCodeInput.value = res.data.access_code;
                form.appendChild(accessCodeInput); 
                document.body.appendChild(form); 
                form.submit(); 
            }    
        }).catch((res) => {  
            toast.error(res.response.data.msg, { autoClose: 3000 }); 
        }); 
    }      
    const handleLogout = async () => {
        ['loginAs', 'accessToken'].forEach(item => localStorage.removeItem(item)); 
        window.location.reload();  
    }    
    return (
        <div className="profileHeader mb-4"> 
            <div className="left"> 
                <div className="profilePicContainer">
                    {details.image ?
                        <img src={BASE_FILE_URL + details.image} className="profilePic" />  
                    :
                        <FaCircleUser size={40} color="gray" />
                    }
                </div>   
                <div>
                    <div className="fs-6 txtBold">{details.name}</div> 
                    <div className="smTxt text-muted">{details.agent_id}</div>
                </div>  
            </div>
            <div className="right">
                {details.expiration_date ? (
                    isExpired ? (
                        <button className="btn btn-success btn-sm fw-bold" onClick={() => upgradeAccount()}>Upgrade Account</button>
                    ) : ( 
                        <h6 className="fw-bold mt-2">Expire: {format(expiryDate, 'dd MMM, yyyy')}</h6>
                    )     
                ) : ( 
                    <button className="btn btn-success btn-sm fw-bold" onClick={() => upgradeAccount()}>Upgrade Account</button>
                )}       
            </div>
            <div className="right">
                <button className="smbtn" onClick={() => handleLogout()}>Logout</button>
            </div>   
        </div>
    ); 
}

export default Info;    